import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** A choice sends its raw `value` (or an array of values for a multiple choice), never `{ value,
 * label }`; a date is the calendar string `AAAA-MM-JJ`. */
export type CorrectDocumentFieldValue = string | number | boolean | readonly string[] | null;

/** `PUT …/fields/{key}/value` — the field key travels in the URL (`encodeURIComponent`, applied by
 * the caller), never in the body. */
class CorrectDocumentField {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly fieldKey: string,
		public readonly value: CorrectDocumentFieldValue,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			value: this.value,
		};
	}
}

export default CorrectDocumentField;
